<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-btn text to="/blog" class="mb-4">
          <v-icon left>mdi-arrow-left</v-icon> Back
        </v-btn>
        
        <div v-if="post">
          <div class="d-flex flex-column flex-md-row justify-space-between align-start align-md-end mb-4">
            <div>
              <h1 class="text-h2 mb-2">{{ post.title }}</h1>
              <p class="text-subtitle-1 grey--text mb-0">{{ post.date }}</p>
            </div>
            <ShareButtons
              v-if="post"
              :url="`https://origami-skin.com/blog/${post.slug}`"
              :title="post.title"
            />
          </div>
          
          <v-divider class="my-4"></v-divider>
          
          <!-- Render Markdown Content -->
          <div 
            class="markdown-body" 
            v-html="processedHtml"
          ></div>

          <v-divider class="my-4"></v-divider>

          <div class="d-flex justify-end mt-4 mb-4">
            <ShareButtons
               v-if="post"
               :url="`https://origami-skin.com/blog/${post.slug}`"
               :title="post.title"
            />
          </div>

          <DisqusThread
            v-if="post"
            :identifier="post.slug"
            :url="`https://origami-skin.com/blog/${post.slug}`"
          />
        </div>
        <div v-else>
          <v-alert type="error">Post not found</v-alert>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getBlogPost, getBlogImage } from "@/utils/blog";
import DisqusThread from "@/components/DisqusThread";
import { analytics, logEvent } from "@/firebase.js";

// Import styles for markdown if needed, e.g. github-markdown-css
// import 'github-markdown-css'; 

export default {
  name: "BlogPost",
  components: {
    DisqusThread,
    ShareButtons: () => import("@/components/ShareButtons"),
  },
  data() {
    return {
      post: null,
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    processedHtml() {
      if (!this.post || !this.post.html) return "";

      // Replace relative image paths with resolved require paths
      const container = document.createElement("div");
      container.innerHTML = this.post.html;

      const images = container.querySelectorAll("img");
      images.forEach((img) => {
        const src = img.getAttribute("src");
        if (src && (src.startsWith("./") || !src.startsWith("http"))) {
          const resolved = getBlogImage(this.post.slug, src);
          if (resolved) {
            img.setAttribute("src", resolved);
          }
        }
      });
      
      return container.innerHTML;
    }
  },
  created() {
    this.loadPost();
  },
  watch: {
    "$route.params.slug": "loadPost",
    language: "loadPost",
  },
  methods: {
    loadPost() {
      const slug = this.$route.params.slug;
      this.post = getBlogPost(slug, this.language);
      
      if (this.post) {
        logEvent(analytics, 'view_blog_post', {
          post_slug: slug,
          post_title: this.post.title,
          post_date: this.post.date
        });
      }
    }
  }
};
</script>



<style>
/* Basic Markdown Styles */
.markdown-body img {
  max-width: 100%;
  border-radius: 8px;
  margin: 1rem 0;
}
.markdown-body h1, .markdown-body h2, .markdown-body h3 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}
.markdown-body p {
  margin-bottom: 1rem;
  line-height: 1.6;
}
</style>
